export function emptyFieldValue(field) {
  if (field.type === 'boolean') return false;
  if (field.type === 'list' || field.type === 'group') return [];
  return '';
}

export function buildSettingsDraft(detail) {
  const values = {};
  (detail.fields || []).filter((field) => field.type !== 'secret').forEach((field) => {
    const value = detail.values?.[field.key] ?? emptyFieldValue(field);
    values[field.key] = JSON.parse(JSON.stringify(value));
  });
  return { enabled: Boolean(detail.enabled), values, replacements: {}, clearSecrets: [] };
}

export function buildSettingsPayload(detail, draft) {
  const secretKeys = (detail.fields || []).filter((field) => field.type === 'secret').map((field) => field.key);
  const clearSecrets = draft.clearSecrets.filter((key) => secretKeys.includes(key));
  const values = { ...draft.values };
  secretKeys.forEach((key) => {
    const replacement = draft.replacements[key];
    if (!clearSecrets.includes(key) && typeof replacement === 'string' && replacement.length > 0) values[key] = replacement;
  });
  return { enabled: draft.enabled, revision: detail.revision, values, clearSecrets };
}

export function reorderItems(items, from, to) {
  if (from < 0 || to < 0 || from >= items.length || to >= items.length) return items;
  const result = [...items];
  const [item] = result.splice(from, 1);
  result.splice(to, 0, item);
  return result;
}

export function mapSettingsErrors(error) {
  const entries = error?.body?.errors || error?.errors || [];
  return Object.fromEntries(entries.map((entry) => [
    String(entry.propertyPath || entry.parameter || entry.field || '').replace(/^values\./, '').replace(/\[(\d+)\]/g, '.$1'),
    entry.message,
  ]).filter(([key]) => key));
}
